import { Injectable, inject } from '@angular/core';

import { SportsUserSettings } from '@frontend/sports/common/client-config-data-access';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { ConfigSettings } from '@frontend/sports/types/models/config-settings';
import { UserSettingsData } from '@frontend/sports/types/models/user-settings';

import { mapEarlyPayoutAcceptance } from '../helpers/early-payout-acceptance';
import { isTurnoverTaxApplied } from '../helpers/is-turnovertax-applied';
import { EarlyPayoutAcceptance } from '../model/early-payout';

/**
 * @whatItDoes Service for managing and accessing sport user settings.
 *
 * @description
 *
 * This service is to allow synchronous fetching of data in the betslip and my-bets modules ,
 * as these modules require the {@link SportsUserSettings} data to be available from the moment they are initialized.
 */

@Injectable({ providedIn: 'root' })
export class SyncUserSettingsService {
    private readonly userSettings = inject(SportsUserSettings);

    get bettingSettings(): UserSettingsData {
        return this.userSettings.bettingSettings;
    }

    get configSettings(): ConfigSettings {
        return this.userSettings.configSettings;
    }

    get isTurnoverTaxApplied(): boolean {
        return isTurnoverTaxApplied(this.userSettings.configSettings);
    }

    get earlyPayoutAcceptance(): Nullable<EarlyPayoutAcceptance.Any | EarlyPayoutAcceptance.Higher> {
        return mapEarlyPayoutAcceptance(this.userSettings.bettingSettings);
    }

    get defaultStake(): number | null {
        // use || instead of ?? to keep `null` in case of 0

        return this.userSettings.bettingSettings.defaultStake || null;
    }
}
